<template>
  <b-modal
    :id="modalId"
    :visible="visible"
    :title="`Detalhes da Solicitação #${solicitacaoDetalhes ? solicitacaoDetalhes.id : ''}`"
    size="lg"
    centered
    no-close-on-backdrop
    @hidden="onModalHidden"
    body-class="p-0"
    header-class="pt-3 pb-3"
    footer-class="pt-3 pb-3"
  >
    <div class="modal-scrollable-content p-3">
      <div v-if="solicitacaoDetalhes">
        <!-- Informações do Solicitante -->
        <section class="mb-3">
          <h5 class="mb-2">Informações do Solicitante</h5>
          <div class="d-flex align-items-center mb-2">
            <b-avatar :src="solicitacaoDetalhes.solicitante.avatar" size="48" class="mr-3" variant="light-secondary"/>
            <div>
              <h6 class="mb-0 font-weight-bold">{{ solicitacaoDetalhes.solicitante.nome }}</h6>
              <small class="text-muted">{{ solicitacaoDetalhes.solicitante.tipo }} - ID: {{ solicitacaoDetalhes.solicitante.id }}</small> <!-- ID Fixo por enquanto -->
            </div>
          </div>
          <b-row>
            <b-col md="6" class="mb-1">
              <span class="text-muted d-block small">E-mail:</span>
              <span class="font-weight-bold">{{ solicitacaoDetalhes.solicitante.email }}</span> <!-- Fixo -->
            </b-col>
            <b-col md="6" class="mb-1">
              <span class="text-muted d-block small">Telefone:</span>
              <span class="font-weight-bold">{{ solicitacaoDetalhes.solicitante.telefone }}</span> <!-- Fixo -->
            </b-col>
            <b-col md="6" class="mb-1">
              <span class="text-muted d-block small">CPF/CNPJ:</span>
              <span class="font-weight-bold">{{ solicitacaoDetalhes.solicitante.cpf }}</span> <!-- Fixo -->
            </b-col>
          </b-row>
        </section>
        <hr class="my-2">
        <!-- Detalhes da Solicitação -->
        <section class="mb-3">
          <h5 class="mb-2">Detalhes da Solicitação</h5>
          <b-row>
            <b-col md="4" sm="6" class="mb-1">
              <span class="text-muted d-block small">ID:</span>
              <span class="font-weight-bold text-uppercase">#{{ solicitacaoDetalhes.id }}</span>
            </b-col>
            <b-col md="4" sm="6" class="mb-1">
              <span class="text-muted d-block small">Data e Hora:</span>
              <span class="font-weight-bold">{{ solicitacaoDetalhes.data }} - 10:32:45</span> <!-- Hora Fixa -->
            </b-col>
            <b-col md="4" sm="12" class="mb-1">
              <span class="text-muted d-block small">Valor:</span>
              <span class="font-weight-bold text-warning h5 mb-0">{{ solicitacaoDetalhes.valor | currency }}</span>
            </b-col>
            <b-col md="4" sm="6" class="mb-1">
              <span class="text-muted d-block small">Método:</span>
              <span class="font-weight-bold">{{ solicitacaoDetalhes.metodo.tipo }} <span v-if="solicitacaoDetalhes.metodo.detalhe">({{ solicitacaoDetalhes.metodo.detalhe }})</span></span>
            </b-col>
            <b-col v-if="solicitacaoDetalhes.metodo.tipo === 'Pix'" md="4" sm="6" class="mb-1">
              <span class="text-muted d-block small">Chave PIX:</span>
              <span class="font-weight-bold">{{ solicitacaoDetalhes.metodo.chave }}</span> <!-- Chave Fixa -->
            </b-col>
            <b-col md="12" class="mb-1">
              <span class="text-muted d-block small">Descrição:</span>
              <span class="font-weight-bold">{{ solicitacaoDetalhes.descricao }}</span> <!-- Descrição Fixa -->
            </b-col>
          </b-row>
        </section>
        <hr class="my-2">
        <!-- Notas de Aprovação -->
        <section>
          <h5 class="mb-2">Notas de Aprovação</h5>
          <b-form-group label="Observações (opcional)" label-for="observacoes-aprovacao" class="mb-0">
            <b-form-textarea
              id="observacoes-aprovacao"
              v-model="observacoes"
              placeholder="Adicione notas sobre esta solicitação..."
              rows="2"
            />
          </b-form-group>
        </section>
      </div>
      <div v-else class="text-center p-5">
        <b-spinner small /> Carregando detalhes...
      </div>
    </div>

    <!-- Footer Customizado com Botões -->
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-end">
        <b-button
          :disabled="solicitacaoDetalhes.status !== 'Pendente'"
          variant="danger"
          class="mr-2"
          @click="handleAction('rejeitar')"
        >
          Rejeitar
        </b-button>
        <b-button
          variant="secondary"
          class="mr-2"
          @click="closeModal"
        >
          Fechar
        </b-button>
        <b-button
          :disabled="solicitacaoDetalhes.status !== 'Pendente'"
          variant="success"
          @click="handleAction('aprovar')"
        >
          Aprovar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormTextarea,
  BButton,
  BSpinner,
} from 'bootstrap-vue'

const currencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
})

export default {
  name: 'DetalhesSolicitacaoModal',
  components: {
    BModal,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormTextarea,
    BButton,
    BSpinner,
  },
  filters: {
    currency(value) {
      if (typeof value !== 'number') {
        return value
      }
      return currencyFormatter.format(value)
    },
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    solicitacaoDetalhes: {
      type: Object,
      default: null,
    },
    modalId: {
      type: String,
      default: 'detalhes-solicitacao-modal',
    },
  },
  data() {
    return {
      observacoes: '',
    }
  },
  watch: {
    solicitacaoDetalhes: {
      handler(newDetails) {
        if (newDetails && newDetails.observacao) {
          this.observacoes = newDetails.observacao
        } else {
          this.observacoes = ''
        }
      },
      immediate: true,
    },
  },
  methods: {
    onModalHidden() {
      this.$emit('update:visible', false)
      this.observacoes = ''
    },
    closeModal() {
      this.$emit('update:visible', false)
    },
    handleAction(action) {
      this.$emit('action', {
        action,
        id: this.solicitacaoDetalhes.id,
        observacoes: this.observacoes,
        solicitante: this.solicitacaoDetalhes.solicitante.id,
        valor: this.solicitacaoDetalhes.valor,
      })
      this.closeModal()
    },
  },
}
</script>

<style scoped>
.h5 {
  font-size: 1.1rem;
}

.modal-scrollable-content {
  max-height: calc(85vh - 160px);
  overflow-y: auto;
}
</style>